/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import { Moment } from "moment";
import { Link } from "react-router-dom";
import Authorization from "../../../../../component/Authorization";
import { mConstants } from "../../../../../helper/constants";
import { IoPagination } from "../../../../../helper/pagination";
import { mUtils } from "../../../../../helper/utils";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { PlanType, PlanUI } from "../../../plan/entity/plan.model";
import { planService } from "../../../plan/service/plan.service";

export interface PlanTableProps {
  pagination: IoPagination<PlanUI>;
  onChange: (page: number, pageSize: number) => void;
  onReload: () => void;
}

function PlanTable(props: PlanTableProps) {
  const planTableColumns: ColumnsType<PlanUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Хэрэглэгчийн нэр",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Эхлэх хугацаа",
      dataIndex: "startDate",
      key: "startDate",
      render: (startDate: Moment) => startDate.format(mConstants.DATE_FORMAT),
    },
    {
      title: "Дуусах хугацаа",
      dataIndex: "endDate",
      key: "endDate",
      render: (endDate: Moment) => endDate.format(mConstants.DATE_FORMAT),
    },
    {
      title: "Дүн",
      dataIndex: "amount",
      key: "amount",
      render: (amount: number) => mUtils.formatCurrency(amount),
    },

    {
      title: "Төрөл",
      dataIndex: "planType",
      key: "planType",
      render: (planType: PlanType) => {
        let type;
        let text;

        switch (planType) {
          case PlanType.BRAND:
            type = "primary";
            text = "Брэнд";
            break;
          case PlanType.PROMOTION:
            type = "success";
            text = "Промошн";
            break;
          case PlanType.CUSTOMER:
            type = "warning";
            text = "Харилцагч";
            break;

          default:
            break;
        }

        return <span className={`badge badge-${type}`}>{text}</span>;
      },
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: PlanUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      key={`action-${record.uuid}`}
                      to={`/plans/${record.uuid}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                } else if (action.type === ActionType.delete) {
                  return (
                    <Authorization roles={["plan-full"]}>
                      <a
                        key={`delete-action-${record.uuid}`}
                        href="#"
                        className="dropdown-item"
                        onClick={() => {
                          Modal.confirm({
                            title: "Баталгаажуулах",
                            content: `Та устгахдаа итгэлтэй байна уу?`,
                            okText: "Үргэлжлүүлэх",
                            cancelText: "Хаах",
                            onOk: () => {
                              planService
                                .deletePlan(record.uuid!)
                                .then(() => props.onReload())
                                .catch((e) => console.error(e));
                            },
                          });
                        }}
                      >
                        <i className={action.icon}></i>
                        {action.text}
                      </a>
                    </Authorization>
                  );
                } else {
                  return <></>;
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];

  const PlanUIs: PlanUI[] = props.pagination.content.map((plan, index) => {
    const actions: Action[] = [
      { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      { icon: "icon-bin2", text: "Устгах", type: ActionType.delete },
    ];
    return {
      ...plan,
      actions: actions,
      index: index + 1,
      key: index,
    };
  });

  return (
    <Table
      className="table table-responsive"
      columns={planTableColumns}
      dataSource={PlanUIs}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.totalElements,
        onChange: props.onChange,
      }}
    />
  );
}
export default PlanTable;
